import { times, divide, minus } from 'number-precision'
import { DEFAULT_PRECISION_MONEY } from 'utils/constants/index'

/**
 *
 * @param {Number} n
 * @returns {Number} factorial of n
 */
export const factorial = n => {
  let fact = 1
  for (let i = 2; i <= n; i++) {
    fact *= i
  }
  return fact
}

/**
 *
 * @param {Number} n
 * @param {Number} r
 * @returns {Number} combination of n over r
 */
export const combination = (n, r) => {
  if (r > n) {
    return 0
  }
  return factorial(n) / (factorial(r) * factorial(n - r))
}

/**
 *
 * @param {string} s
 * @returns {Number} count of one
 */
export const countOnes = (s) => {
  let count = 0
  for (const i of s) {
    if (i === '1') {
      count++
    }
  }
  return count
}

/**
 *
 * @param {number} value
 * @param {number} precision
 * @returns {number} Returns precision value for specified decimal places
 */
export const getPrecision = (value = 0, precision = DEFAULT_PRECISION_MONEY) => {
  const precisionDivide = Math.pow(10, precision)
  const result = divide(Math.trunc(times(value, precisionDivide)), precisionDivide)
  return result || 0
}

/**
 *
 * @param {Object} gameSettings
 * @param {Number} probability
 * @returns {Number} Calculated Odds
 */
export const calculateDiceOdds = ({ minOdd, maxOdd, houseEdge }, odds) => {
  const deductHouseEdge = minus(1, divide(houseEdge, 100))
  let newOdds = times(odds, deductHouseEdge)
  newOdds = Math.min(maxOdd, newOdds) // max odd capping
  newOdds = Math.max(minOdd, newOdds) // min odd capping
  newOdds = getPrecision(newOdds, 4)
  return newOdds
}

/**
 *
 * @param {Number} numberOfCoins
 * @param {Number} minimumChosenOutcome
 * @returns {Number} probability of minimum X number of favorable outcomes
 */
export const getCoinOutcomeProbability = (numberOfCoins, minimumChosenOutcome) => {
  const n = numberOfCoins - minimumChosenOutcome
  let sum = 0
  for (let i = 0; i <= n; i++) {
    sum += combination(numberOfCoins, i)
  }
  return sum / 2 ** numberOfCoins
}
